import React from "react"
import Loader from "../components/Loader/Loader"
import { Space, Button } from "antd"

interface ExpandBtnProps {
  onClick: () => void
  text: string
  isLoaded?: boolean
}

const ExpandBtn: React.FC<ExpandBtnProps> = ({ onClick, text, isLoaded = false }) => {
  return (
    <Button className="w-100" onClick={onClick} disabled={isLoaded} style={{ maxWidth: 200 }}>
      <Space>
        {text}
        {isLoaded && <Loader />}
      </Space>
    </Button>
  )
}

export default ExpandBtn
